import PropTypes from "prop-types";
import { classNames } from "primereact/utils";
import { ProgressBar } from "primereact/progressbar";

export default function ModuleChartRank({
  className = "",
  styles = {},
  data = [],
  options = {},
}) {
  const { activeColor = "#13a8a8", showValue = false } = options;

  return (
    <div className={classNames("inline-block w-full", className)} style={styles}>
      {data.map((item, index) => (
        <div
          key={`rank_${item.leftLabel ?? ""}-${item.rightLabel ?? ""}-${item.percent ?? ""}`}
          className={classNames({
            "mt-2": index !== 0,
          })}
        >
          <div className="flex align-items-center text-white">
            <span className="mr-2">{item.leftLabel}</span>
            <span className="ml-auto">{item.rightLabel}</span>
          </div>
          <ProgressBar
            className="bg-dark-l"
            value={item.percent}
            showValue={showValue}
            color={activeColor}
          />
        </div>
      ))}
    </div>
  );
}

ModuleChartRank.propTypes = {
  className: PropTypes.string,
  styles: PropTypes.object,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      leftLabel: PropTypes.string,
      rightLabel: PropTypes.string,
      percent: PropTypes.number,
    }),
  ),
  options: PropTypes.shape({
    activeColor: PropTypes.string,
    showValue: PropTypes.bool,
  }),
};
